"use client";

interface LoadMoreProps {
  onLoadMore: () => void;
  hasMore: boolean;
  loading?: boolean;
}

const LoadMore = ({ onLoadMore, hasMore, loading = false }: LoadMoreProps) => {
  if (!hasMore) return null;

  return (
    <div className="load-more-section text-center mt-5">
      <button
        onClick={onLoadMore}
        disabled={loading}
        className="desilo-link-btn btn-pill"
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2 text-white" role="status" aria-hidden="true"></span>
            Loading...
          </>
        ) : (
          <>
            Load more
            {/* <span>
              <i className="fa-solid fa-arrow-right arry1"></i>
            </span> */}
          </>
        )}
      </button>
    </div>
  );
};

export default LoadMore;

